import { GUIDE_REGISTRY } from '@/config/guide/registry';

/**
 * Assemble the `guide` i18n namespace from every domain's own language files.
 *
 * The help copy lives in a SECOND namespace rather than in `common.json` for
 * two reasons: `common.json` is already ~1800 keys and this roughly doubles
 * it, and — more importantly — per-domain files are what let many domains be
 * written at once without merge conflicts on one shared catalog.
 *
 * Merging is per-language and per-key, so a domain that has not been
 * translated into (say) Khmer simply contributes nothing for that language
 * and i18next falls back to Thai for those keys alone. The page still renders;
 * it does not collapse into raw dotted key paths.
 */
export function buildGuideResources(): Record<string, { guide: Record<string, unknown> }> {
  const resources: Record<string, { guide: Record<string, unknown> }> = {};
  for (const domain of GUIDE_REGISTRY) {
    for (const [lang, copy] of Object.entries(domain.copy)) {
      const bucket = (resources[lang] ??= { guide: {} });
      Object.assign(bucket.guide, copy);
    }
  }
  return resources;
}
